/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiAssistanceIncidentType,
    ApiAssistanceIncidentTypeFromJSON,
    ApiAssistanceIncidentTypeFromJSONTyped,
    ApiAssistanceIncidentTypeToJSON,
    ApiAssistanceRequestStatus,
    ApiAssistanceRequestStatusFromJSON,
    ApiAssistanceRequestStatusFromJSONTyped,
    ApiAssistanceRequestStatusToJSON,
    ApiAssistanceRequestTowTruckDriver,
    ApiAssistanceRequestTowTruckDriverFromJSON,
    ApiAssistanceRequestTowTruckDriverFromJSONTyped,
    ApiAssistanceRequestTowTruckDriverToJSON,
    ApiDestination,
    ApiDestinationFromJSON,
    ApiDestinationFromJSONTyped,
    ApiDestinationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ViewIframeResponse
 */
export interface ViewIframeResponse {
    /**
     * 
     * @type {Date}
     * @memberof ViewIframeResponse
     */
    submitTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ViewIframeResponse
     */
    slaTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof ViewIframeResponse
     */
    yawayId: number;
    /**
     * 
     * @type {string}
     * @memberof ViewIframeResponse
     */
    requestExternalId: string;
    /**
     * 
     * @type {string}
     * @memberof ViewIframeResponse
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof ViewIframeResponse
     */
    licensePlate: string;
    /**
     * 
     * @type {ApiAssistanceIncidentType}
     * @memberof ViewIframeResponse
     */
    incidentType: ApiAssistanceIncidentType;
    /**
     * 
     * @type {string}
     * @memberof ViewIframeResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewIframeResponse
     */
    vehicle?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewIframeResponse
     */
    service: string;
    /**
     * 
     * @type {ApiAssistanceRequestStatus}
     * @memberof ViewIframeResponse
     */
    status: ApiAssistanceRequestStatus;
    /**
     * 
     * @type {Array<ApiDestination>}
     * @memberof ViewIframeResponse
     */
    destinations?: Array<ApiDestination>;
    /**
     * 
     * @type {ApiAssistanceRequestTowTruckDriver}
     * @memberof ViewIframeResponse
     */
    driver?: ApiAssistanceRequestTowTruckDriver;
}

export function ViewIframeResponseFromJSON(json: any): ViewIframeResponse {
    return ViewIframeResponseFromJSONTyped(json, false);
}

export function ViewIframeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewIframeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'submitTime': !exists(json, 'submitTime') ? undefined : (new Date(json['submitTime'])),
        'slaTime': !exists(json, 'slaTime') ? undefined : (new Date(json['slaTime'])),
        'yawayId': json['yawayId'],
        'requestExternalId': json['requestExternalId'],
        'region': json['region'],
        'licensePlate': json['licensePlate'],
        'incidentType': ApiAssistanceIncidentTypeFromJSON(json['incidentType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'vehicle': !exists(json, 'vehicle') ? undefined : json['vehicle'],
        'service': json['service'],
        'status': ApiAssistanceRequestStatusFromJSON(json['status']),
        'destinations': !exists(json, 'destinations') ? undefined : ((json['destinations'] as Array<any>).map(ApiDestinationFromJSON)),
        'driver': !exists(json, 'driver') ? undefined : ApiAssistanceRequestTowTruckDriverFromJSON(json['driver']),
    };
}

export function ViewIframeResponseToJSON(value?: ViewIframeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'submitTime': value.submitTime === undefined ? undefined : (value.submitTime.toISOString()),
        'slaTime': value.slaTime === undefined ? undefined : (value.slaTime.toISOString()),
        'yawayId': value.yawayId,
        'requestExternalId': value.requestExternalId,
        'region': value.region,
        'licensePlate': value.licensePlate,
        'incidentType': ApiAssistanceIncidentTypeToJSON(value.incidentType),
        'description': value.description,
        'vehicle': value.vehicle,
        'service': value.service,
        'status': ApiAssistanceRequestStatusToJSON(value.status),
        'destinations': value.destinations === undefined ? undefined : ((value.destinations as Array<any>).map(ApiDestinationToJSON)),
        'driver': ApiAssistanceRequestTowTruckDriverToJSON(value.driver),
    };
}

